import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { school } from "@/data/content";

export default function Reviews() {
  return (
    <section className="relative py-24 md:py-32 bg-cream overflow-hidden">
      <div className="mx-auto max-w-5xl px-5 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="inline-flex flex-col items-center"
        >
          <Quote className="h-12 w-12 text-brand-yellow mb-6" strokeWidth={2.5} />
          <div className="flex items-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-8 w-8 text-brand-yellow fill-brand-yellow" strokeWidth={0} />
            ))}
          </div>
          <p className="font-display font-700 text-ink text-6xl md:text-7xl mb-3">{school.googleRating}</p>
          <p className="font-body font-600 text-ink-soft text-lg mb-10">Avaliação das famílias no Google</p>

          <h2 className="font-display font-600 text-ink text-3xl md:text-4xl leading-snug max-w-3xl">
            “Queremos que as famílias sintam a mesma confiança e segurança que sentimos ao escolher este lugar para nossos próprios filhos.”
          </h2>
          <p className="font-body font-700 text-brand-orange mt-6">— Instituto Educacional Recriar</p>
        </motion.div>
      </div>
    </section>
  );
}
